// extracted by mini-css-extract-plugin
module.exports = {"moreInsights":"ewPUxhVE","count":"pa0XQlg7"};